import styled from '@emotion/styled';

export default styled.span({
  flexGrow: 1,
});
